import { LocalAtRecord } from '../../db';
import { JobsFieldSet } from '@rogoag/airtable/crm';

/**
 * Domain entity representing a job in the "To Process" list for Skips Processing
 * These are jobs that need skips processing (fetchJobsToProcess)
 */
export class SkipsProcessingJobToProcess {
  public readonly id: string;
  public readonly name: string;
  public readonly jobRecord: LocalAtRecord<JobsFieldSet>;
  public readonly operator: string;
  public readonly sampleDate: string;
  public readonly rogoJobId: string;

  private _isActive: boolean = false;

  constructor(jobRecord: LocalAtRecord<JobsFieldSet>) {
    this.id = jobRecord.id;
    this.name = jobRecord.get('Name') || jobRecord.id;
    this.jobRecord = jobRecord;

    // Operator Name is an array, get first element
    const operatorName = jobRecord.get('Operator Name');
    this.operator = Array.isArray(operatorName) && operatorName.length > 0 ? operatorName[0] : '';

    this.sampleDate = jobRecord.get('Sample Date') || '';
    this.rogoJobId = jobRecord.get('Rogo Job ID') || '';
  }

  get isActive(): boolean {
    return this._isActive;
  }

  setActive(active: boolean): void {
    this._isActive = active;
  }
}
